import {
  FETCH_VOICE_PROFILE_REQUEST,
  FETCH_VOICE_PROFILE_SUCCESS,
  FETCH_VOICE_PROFILE_FAILURE,
  UPDATE_VOICE_PROFILE_REQUEST,
  UPDATE_VOICE_PROFILE_SUCCESS,
  UPDATE_VOICE_PROFILE_FAILURE,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
} from './actions';

const initialState = {
  voiceProfile: {
    lang: '',
    vocabulary: [],
  },
  loading: false,
};

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_VOICE_PROFILE_REQUEST:
    case UPDATE_VOICE_PROFILE_REQUEST:
    case UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_VOICE_PROFILE_SUCCESS:
      return {
        ...state,
        voiceProfile: action.payload,
        loading: false,
      };
    case FETCH_VOICE_PROFILE_FAILURE:
    case UPDATE_VOICE_PROFILE_SUCCESS:
    case UPDATE_VOICE_PROFILE_FAILURE:
    case UPDATE_PASSWORD_SUCCESS:
    case UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
